import { useCodesHierarchy } from './useCodesSidebar';
import { useCodeBookCollapseState } from './useCollapseState';
import { useCodesWithCollapse } from './useCodesWithCollapse';

/**
 * Hook that enhances useCodesHierarchy output with codebook collapse state
 * @param {string|number} projectId - Project ID
 * @returns {Object} Hierarchical codes with collapse state and loading status
 */
export function useCodebookCodes(projectId) {
  // Get hierarchical codes using existing hook
  const codesData = useCodesHierarchy(projectId);
  
  // Get codebook collapse state
  const collapseData = useCodeBookCollapseState(projectId);
  
  // Enhance codes with collapse state using the modular hook
  return useCodesWithCollapse(codesData, collapseData);
}